<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="库存" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col" style="width:100px">
							<storehouse-input v-model="filterStorehouse"></storehouse-input>
						</div>
						<div class="operator-col" style="width:120px">
							<classify-input v-model="filterClassify" size="mini"></classify-input>
						</div>
						<div class="operator-col" style="width:120px">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
						<div class="operator-col" style="width:180px">
							<el-input
									size="mini"
									v-model="filterTableSearch"
									placeholder="SPU 名/码"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<editor-relateid
									style="width:100px"
									size="mini"
									v-model="filterModel"
									data-model-name="Model"
									:name-fields="['name']"
									:params="{allowCreate:false,placeholder:'搜索尺寸'}"
							></editor-relateid>
						</div>
					</div>
					<sum-table v-if="!showSelect"
							ref="sumTable"
							:data-model="editorDataModel"
							:storehouse-filter="filterStorehouse"
							:search-filter="filterTableSearch"
							:kv-filter="kvFilter"
							:fields="sumFields"
							list-url="reserve/sum_all_stocks"
					></sum-table>
					<stock-table
							:showSelect = showSelect
							:list-ops="[]"
							:has-delete="false"
							ref="listTable"
							:data-model="editorDataModel"
							@doedit="handleEdit($event)"
							@dosort="handleSort"
							:search-filter="filterTableSearch"
							:kv-filter="kvFilter"
							:storehouse-filter="filterStorehouse"
							@selectChange = "selectChangeHandel"
							list-url="reserve/list_all_stocks"
					></stock-table>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterSeason from "@/mixins/Filter/FilterSeason.js";
import FilterModel from "@/mixins/Filter/FilterModel.js";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import FilterStorehouse from "@/mixins/Filter/FilterStorehouse.js";

import StockTable from "@/views/Reserve/subs/StockTable.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import His from "@/views/Reserve/subs/His.vue";
import EditReserveInbound from "@/views/Reserve/subs/EditReserveInbound.vue";
import EditInbound from "@/views/Inventory/subs/EditInbound.vue";
import EditOutBound from "@/views/Inventory/subs/EditOutBound.vue";
import Outbound from "@/views/Inventory/Outbound.vue";
import EditReserveOutbound from "@/views/Reserve/subs/EditReserveOutbound.vue";

export default {
	mixins: [CurdPage, Filters, FilterSeason, FilterModel, FilterClassify, FilterStorehouse],
	components: {
		StockTable,
	},
	props: {
		showSelect:{
			type:Boolean,
			default:false
		}
	},
	data() {
		return {
			loadings: {
				main: false,
				sums: false,
			},
      options: [{
        value: '',
        label: '全部'
      },{
        value: 0,
        label: '不区分性别'
      }, {
        value: 1,
        label: '男'
      }, {
        value: 2,
        label: '女'
      }],
      value:'',

			editorDataModel: "Reserve_item",
			filterTableSearchColor: "",
			itemData:[]
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),

		productFilters() {
			let filter = [];
			if (this.filterBrand._id != "") {
				filter.push({ k: "brand", t: "_id", v: this.filterBrand._id });
			}
			if (this.filterClassify.length != 0) {
				filter.push({
					k: "classify",
					t: "classify",
					v: this.filterClassify[this.filterClassify.length - 1]._id,
				});
			}
			return filter;
		},
		sumFields() {
			return [
				{
					name: "count",
					title: "种类",
				},
				{
					name: "sum_amount",
					title: "总数量",
				},
				// {
				// 	name: "sum_cost_total",
				// 	title: "总金额",
				// 	prefix: this.$root.currencyCode,
				// },
        {
          name: "sum_price_1",
          title: "零售价总计",
          prefix: this.$root.currencyCode,
        },
			].filter(item => {
				if (!this.userPrivilegeMapping[59] && item.name == "sum_cost_total") {
					return false;
				}
				if (!this.userPrivilegeMapping[53] && item.name == "sum_amount") {
					return false;
				}
				return true;
			});
		},
	},
	watch: {
	},
  methods:{
		selectChangeHandel(val){
			this.$emit('selectChange', val);
		}
  }
};
</script>
<style lang="scss" scoped>
</style>
